import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import ConvertTextToSpeech from '../../customeHooks/convertTextToSpeech';

const mapStateToProps = (state) => {
    const {
        rightFeedbackProps,
        answerCount,
        leftFeedbackProps,
    } = state.rootReducer.testPageDetails;

    return {
        rightFeedbackProps,
        answerCount,
        leftFeedbackProps,
    }
}


const IeltsIncorrect = ({
    answerCount,
    rightFeedbackProps: {
        feedbackQuestionNo,
        feedbackQuestion,
        defaultFeedback,
        correctAnswer,
        score,
        fileUrl,
        json_response : {
            ielts : {
                fidelity_class,
                overall_score,
                overall_metrics : {
                    audio_length,
                    ielts_score,
                    pauses,
                    pte_score,
                    wcm,
                    syllable_count,
                    word_count,
                    pause_duration,
                    phone_count,
                    mlr,
                },
                detailed,
            },
        },
    },
    leftFeedbackProps: {
        questionId,
        qtype,
    },

}) => {
    useEffect(() => {
        ConvertTextToSpeech({ correctAnswer, elementClass: 'correct-answer-', questionId, score });
    }, [correctAnswer,
        questionId,
        score,
    ])

    let stext = 'Correct'
    let stextClass = "text-success stext"

    if(fidelity_class != "CORRECT")
    {
        stext = 'Erroneous'
        stextClass = "text-danger stext"
    }

    let ofeedback = ""
    let ofeedbackClass = "text-danger otext"

    if(overall_score >= 90)
    {
        ofeedback = 'Excellent. Native or native-like.'
        ofeedbackClass = "text-success otext"
    } else if(overall_score >=80 && overall_score < 90)
    {
        ofeedback = 'Very Good and clearly intelligible.'
        ofeedbackClass = "text-success otext"
    } else if(overall_score >=70 && overall_score < 80)
    {
        ofeedback = 'Good. Intelligible but with one or two evident mistakes.'
        ofeedbackClass = "text-warning otext"
    } else if(overall_score >= 60 && overall_score < 70)
    {
        ofeedback = 'Fair. Possibly not intelligible with several evident mistakes.'
        ofeedbackClass = "text-danger otext"
    } else {
        ofeedback = 'Poor and must be reattempted.'
        ofeedbackClass = "text-danger otext"
    }

    return (
        <>
        <span> 
            {qtype == 'IELTS' ? (
            <div>
              <h3 className={ofeedbackClass}>{ofeedback}</h3>
              <div>
              <div className="tables-blocks">
                        <table className="tables-blocks__word">
                            <tbody>
                                <tr>
                                    <th>Fluency Score</th>
                                    <th>IELTS Score</th>
                                    <th>PTE Score</th>
                                    <th>Words per Minute</th>
                                </tr>
                                <tr>
                                    <td>{overall_score}</td>
                                    <td>{ielts_score}</td>
                                    <td>{pte_score}</td>
                                    <td>{wcm}</td>
                                </tr>
                            </tbody>
                            </table>
             </div>
              </div>
              <div className="record-container">
                 <div className="audio-player audio-player-wrong">
                    <audio src={fileUrl} controls controlsList="nodownload"></audio>
                    <small>Your answer</small>
                 </div>

                {qtype !== 'LA' && 
                    <div className="audio-player audio-player-correct">
                        <audio src="" controls controlsList="nodownload" id={'correct-answer-'+questionId}></audio>
                        <small>Check this correct answer</small>
                     </div>}
              </div>
                <div className="tables">
                    <div className="tables-blocks">
                    <h4 class="ielts_detailed_score">Detailed score breakup</h4>
                        <table className="tables-blocks__word">
                            <tbody>
                                <tr>
                                    <th>Word</th>
                                    <th>Score</th>
                                </tr>
                                {detailed.words.map(
                                    function(word, index) {
                                        return (
                                            <tr key={index}>
                                            {word.quality_score <= 80 ? (
                                                <td><span className="pronounce ieltsalert">{word.word}</span></td>
                                            ): (
                                               <td><span className="pronounce">{word.word}</span></td>
                                            )}
                                                <td>{word.quality_score}%</td>
                                            </tr>
                                        );
                                    }.bind(this)
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            ): null}
        </span>
        <span>
            {qtype !== 'IELTS' ? (
            <div>
              <h4 className="text-danger">That’s Incorrect.</h4>
              <h4 className="text-danger">{overall_score}</h4>
              <div className="record-container">
                 <div className="audio-player audio-player-wrong">
                    <audio src={fileUrl} controls controlsList="nodownload"></audio>
                    <small>Your answer</small>
                 </div>

                {qtype !== 'LA' && 
                    <div className="audio-player audio-player-correct">
                        <audio src="" controls controlsList="nodownload" id={'correct-answer-'+questionId}></audio>
                        <small>Check this correct answer</small>
                     </div>}
              </div>
              <input type="hidden" name="choosen-answer" className="choosen-answer" />
             </div>
             ): null}
           </span>
        </>
    );
}

export default connect(mapStateToProps)(IeltsIncorrect);